/* eslint-disable @typescript-eslint/no-unsafe-call, no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Button, Typography, Card, Popconfirm, Checkbox, Col, Row } from 'antd';
import { UploadOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { startCase } from 'lodash';
import { useQuery, useMutation } from '@apollo/client';
import { DELETE_DOCUMENT } from 'src/graphql';
import { IDocuments, IDocumentsTypes } from '../interfaces';
import NoData from './NoData';
import { COMPLETE, REQUIRED } from '../services';
import DocsOnboardCard from './DocsOnboardCard';
import { PrimaryButton } from './Buttons';
import { errorMessage, successMessage } from '../utils/Notifications';

const { Grid } = Card;
const { Title, Text } = Typography;

interface DocumentsCardProps {
    documents: IDocuments[];
    documentTypes: IDocumentsTypes[];
    loading?: boolean;
    isAdmin?: boolean;
    userId?: string;
    getDocuments: () => void;
}

function DocumentsCard(props: DocumentsCardProps): JSX.Element {
    const [deleteDocument] = useMutation(DELETE_DOCUMENT);
    const { documents, documentTypes, loading, getDocuments, isAdmin, userId } = props;
    const [update, setUpdate] = useState<boolean>(false);
    const [showUpload, setShowUpload] = useState<boolean>(true);
    const hasIncompleteStatus = documents.some((document) => document.status !== 'COMPLETE');

    const handleDeleteDocument = (record: IDocuments) => {
        const documentId = record.id;
        deleteDocument({
            variables: {
                documentId,
            },
        })
            .then(() => {
                getDocuments();
                setShowUpload(false);
            })
            .catch(() => {
                errorMessage('Failed to delete document');
            });
    };

    const getDocumentName = (documentType: string): string => {
        const resultObject: IDocumentsTypes | undefined = documentTypes.find((obj) => obj.key === documentType);
        let documentName = '';
        if (resultObject !== undefined && resultObject.name !== undefined) {
            documentName = resultObject.name;
        }
        return documentName;
    };

    return (
        <div
            style={{
                padding: '7px',
                marginLeft: '5px',
                marginRight: '5px',
                background: '#ffffff',
                borderRadius: '15px',
            }}
        >
            <Row>
                <Col span="24" style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                    <Text className="card-heading">Documents</Text>
                </Col>
                <Col span="24" style={{ marginTop: '-27px', paddingLeft: '10px' }}>
                    <Text style={{ fontWeight: 'bold', fontSize: '20px', color: '#EE773B' }}>___</Text>
                </Col>
            </Row>
            <Card
                className={`card ${update ? 'card-body-center' : ''}`}
                style={{ paddingTop: '0px', marginTop: '0px' }}
                loading={loading}
                extra={
                    update ? (
                        <PrimaryButton title="Done" small onClick={() => setUpdate(!update)} />
                    ) : isAdmin ? (
                        <PrimaryButton title="Edit" small onClick={() => setUpdate(!update)} />
                    ) : hasIncompleteStatus ? (
                        <Button
                            style={{ color: '#EE773B', fontSize: '20px' }}
                            type="link"
                            onClick={() => setUpdate(!update)}
                        >
                            <UploadOutlined />
                            <Text style={{ fontWeight: 'bold', fontSize: '17px', color: '#EE773B' }}>Upload</Text>{' '}
                        </Button>
                    ) : (
                        ''
                    )
                }
            >
                {update ? (
                    <DocsOnboardCard
                        documents={documents}
                        documentTypes={documentTypes}
                        isAdmin={isAdmin}
                        userId={userId}
                    />
                ) : documents?.length > 0 ? (
                    documents.map((document) => (
                        <Grid key={document.id} hoverable={false} style={{ border: '0px solid #ffffff' }}>
                            <Row>
                                <Col span={18}>
                                    <Checkbox className="full-width" checked={document.status === COMPLETE}>
                                        <Row
                                            className="documents-list display-block"
                                            onClick={() => setUpdate(!update)}
                                        >
                                            {getDocumentName(document.type)} &nbsp;
                                            <span
                                                className={
                                                    document.status === REQUIRED && !document.receivedOn
                                                        ? 'red'
                                                        : 'green'
                                                }
                                            >
                                                ({document.status})
                                            </span>
                                        </Row>
                                    </Checkbox>
                                </Col>
                                <Col span={6} className="message-description">
                                    <span className="float-right">
                                        {document.status === REQUIRED && !document.receivedOn ? (
                                            <span className="red">Due by: {moment(document.dueBy).format('ll')}</span>
                                        ) : (
                                            !!document.url && (
                                                <>
                                                    <div className="flex">
                                                        <a
                                                            href={document.url}
                                                            download
                                                            className="hoverable-icon black"
                                                        >
                                                            <DownloadOutlined style={{ fontSize: '16px' }} />
                                                        </a>
                                                        &nbsp; &nbsp;
                                                        <Popconfirm
                                                            title="Sure to delete?"
                                                            onConfirm={() => handleDeleteDocument(document)}
                                                        >
                                                            <DeleteOutlined className="hoverable-icon" />
                                                        </Popconfirm>
                                                    </div>
                                                </>
                                            )
                                        )}
                                    </span>
                                </Col>
                            </Row>
                        </Grid>
                    ))
                ) : (
                    <NoData />
                )}
            </Card>
        </div>
    );
}

export default DocumentsCard;
